
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 14.4c3.536 0 6.4-2.864 6.4-6.4 0-3.536-2.864-6.4-6.4-6.4A6.398 6.398 0 001.6 8c0 3.536 2.864 6.4 6.4 6.4zM8 0c4.416 0 8 3.584 8 8s-3.584 8-8 8c-4.424 0-8-3.6-8-8 0-4.416 3.584-8 8-8zm.4 4v4.2l3.6 2.136-.6.984L7.2 8.8V4h1.2z","fill":"#263238"}})])
          )
        }
      }
    